import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { localDate } from "../../lib/api";
import { Field } from "./useAdminApi";

const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const DailyTab = ({ songs, call }) => {
  const [picks, setPicks] = useState([]);
  const [day, setDay] = useState(localDate());
  const [songId, setSongId] = useState("");
  const load = () => call("get", "/admin/daily-picks").then(setPicks).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async (e) => {
    e.preventDefault();
    try { await call("put", `/admin/daily-picks/${day}`, { song_id: songId }); } catch { return; }
    toast.success("Comptine du jour enregistrée"); load();
  };
  const remove = async (d) => { try { await call("delete", `/admin/daily-picks/${d}`); } catch { return; } toast.success("Choix retiré"); load(); };
  const title = (id) => songs.find((s) => s.id === id)?.title || "Comptine supprimée";

  return (
    <div>
      <p className="text-sm opacity-80">Sans choix pour une date, une comptine publiée est choisie automatiquement chaque jour.</p>
      <form onSubmit={save} className="mt-4 grid gap-3 sm:grid-cols-[180px_1fr_auto] sm:items-end">
        <Field label={day ? `Date : ${fmt(day)}` : "Date"}><Input type="date" lang="fr" required value={day} onChange={(e) => setDay(e.target.value)} data-testid="admin-daily-date" /></Field>
        <Field label="Comptine">
          <Select value={songId} onValueChange={setSongId}>
            <SelectTrigger data-testid="admin-daily-song"><SelectValue placeholder="Choisir une comptine" /></SelectTrigger>
            <SelectContent>{songs.filter((s) => s.published).map((s) => <SelectItem key={s.id} value={s.id}>{s.title}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        <Button type="submit" disabled={!songId} className="rounded-full bg-[#38B6FF] hover:bg-[#1fa3ee]" data-testid="admin-daily-save">Enregistrer</Button>
      </form>
      <ul className="mt-5 space-y-3" data-testid="admin-daily-list">
        {picks.length === 0 && <li className="text-sm opacity-70">Aucune date choisie pour l'instant.</li>}
        {picks.map((p) => (
          <li key={p.date} className="flex items-center gap-3 rounded-[20px] bg-white p-3 shadow-sm" data-testid={`admin-daily-${p.date}`}>
            <div className="flex-1"><p className="font-bold capitalize">{fmt(p.date)}</p><p className="text-sm">{title(p.song_id)}</p></div>
            <Button variant="ghost" size="icon" aria-label="Retirer" onClick={() => remove(p.date)} data-testid={`admin-daily-delete-${p.date}`}><Trash2 className="w-5 h-5 text-[#F0303A]" /></Button>
          </li>
        ))}
      </ul>
    </div>
  );
};
